const mainUa = {
  projectText:
    "Консультант із причинно-наслідкових зв’язків та майстер Матриці Долі",
  heroChoose: "Більше жодних сумнівів у собі та «магії» власних дій.",
  heroButton1: "Перейти до послуг",
  heroButton2: "Калькулятор матриці",
  projectAuthor: "Освіта",
  authroDesc:
    "<0>Дарина Дупак</0> — Професійний ініційований консультант із призначення, діагностики та корекції долі.",
  aboutAuthorWork1: "Дипломований менеджер соціокультурної діяльності",
  aboutAuthorWork2:
    "Проводжу трансформаційні івенти. Працюю над створенням особистісних брендів.",
  aboutAuthorWork3:
    "Працюю за авторським методом Наталії Ладіні, відомого як Матриця Долі.",
  aboutAuthorWork4:
    "Володію поглибленими розрахунками методу і техніками зцілення.",
  aboutAuthorWork5:
    "Здобула ступінь магістра психології в Національному університеті імені В. І. Вернадського",
  aboutAuthorWork6:
    "Вивчаю кармічний менеджмент і причинно-наслідкові зв'язки в Інституті Азійської Класики",
  aboutKarmaTitle: "ТИ — і є справжня карма",
  aboutKarmaDesc1:
    "Карма — це хід твоїх думок, рух розуму, а не покарання чи «обратка».",
  aboutKarmaDesc2:
    "Алмазна мудрість — це система досягнення цілей через етичні та добрі вчинки.",
  aboutKarmaNearHands:
    "Думки, слова, вчинки — усе це дії, які ти здійснюєш щодня, здебільшого навіть автоматично. І саме вони формують твоє сприйняття: хто для тебе «хороший» чи «поганий», а що — проблема чи можливість.",
  aboutKarmaTextUnderContainer: "І це хороша новина, адже якщо так...",
  aboutKarmaResultText: "Твоя доля справді у твоїх руках!",
  whatIsMatrixTitle1: "Що таке",
  whatIsMatrixTitle2: "Матриця Долі?",
  whatIsMatrixMatrixCreator: "Метод Наталії Ладіні, якому понад 20 років.",
  whatIsMatrixAboutMethod:
    "Цей метод фактично є дзеркалом ваших життєвих сценаріїв, відображених у 22 архетипах. Це унікальний інструмент для дослідження призначення та корекції життя через вчинки й нові звички.",
  whatIsMatrixLinkToCalculator: "Розрахувати матрицю",
  matrixMinusAndPlusTitle1: "Матриця в мінусі",
  matrixMinusAndPlusTitle2: "Матриця в плюсі",
  matrixMinusAndPlusCheckboxText: "Пропрацювати матрицю",
  matrxiMinusPuzzle: "постаєш перед фінансовими труднощами",
  waysToTransformationTitle: "Я проведу тебе до істинних бажань твоєї душі.",
  waysToTransformationAbout:
    "Ти не залишишся наодинці з багажем нової інформації про себе, оскільки я гарантую:",
  waysToTransformationWarning:
    "*Необережне відкриття доленосних програм, без готовності працювати над ними, може мати негативні наслідки. Тому для вашої безпеки всі повноцінні консультації по матриці НЕ проводяться без готовності клієнта йти до трансформації.",
  waysToTransformationConsultationTitle: "На  Консультації",
  waysToTransformationConsultationText1:
    "Індивідуальний підхід до кожного клієнта",
  waysToTransformationConsultationText2:
    "Унікальні інтерпретації зв'язків енергій у твоїй матриці",
  waysToTransformationConsultationText3:
    "Інформацію, яка з часом розкриється на новому, глибинному рівні",
  waysToTransformationTransformationWayTitle: "На  Трансформації",
  waysToTransformationTransformationWayText1:
    "Енергетичну та інформаційну підтримку",
  waysToTransformationTransformationWayText2:
    "Надання комплексу рекомендацій та матеріалів - кармічний рецепт",
  waysToTransformationTransformationWayText3:
    "Різноманітні методики та практики",
  waysToTransformationTransformationWayText4:
    "Відстеження процесу трансформації за допомогою точок контролю між етапами у форматі дзвінків",
  ServicesAndPriceTitle: "Послуги",
  ServicesTypesInfo:
    "Ці три формати консультацій підходять для будь-якого запиту. Просто обирай формат, у якому готовий працювати, і приходь. Усе інше, від інструментів до необхідних розрахунків, підберу я.",
  ServicesAndPriceFourStages: "Матриця Долі: всі рівні оригінального методу",
  ServicesAndPriceWarning: "*Кожен рівень опрацьовується послідовно",
  ServicesAndPriceDetail: "Детальніше",
  ServicesAndPriceConsultationsIndividualRequest:
    "Також можна розібрати будь-яку іншу тему за індивідуальним запитом.",
  ServicesAndPriceConsultationsTitle: "Особливі формати",
  ServicesAndPriceExpressServicesTitle: "Експрес-послуги",
  ServicesAndPriceExpressServicesAdditionalInfo1:
    "Також ви можете подарувати своїм близьким",
  ServicesAndPriceExpressServicesAdditionalInfo2: "на будь-яку послугу.",
  ServicesAndPriceExpressServicesCert: "сертифікат",
  masterClassTitle: "Матеріали для <1>самостійної роботи</1>",
  cost: "Вартість:",
  feedback: "Відгуки",
  feedbackDesc: "Я з радістю стану твоїм провідником у новий етап твого життя!",
  moreFeedbacks: 'Більше відгуків',
  calculate: "Дізнайся",
  yourMatrix: "свою Матрицю Долі",
  aboutCalc:
    "Отримай правильний розрахунок за оригінальним методом Наталії Ладіні – від базової Матриці до глибинних рівнів.",
  infoAboutCalc:
    "* Калькулятор на 100% відповідає класичному обчисленню «Матриця Долі» Наталії Ладіні",
  calcBtn: "Розрахувати",
  freeRecommendationTitle: "Багато корисної інформації у моїх соц.мережах:",
  peopleAsk: "Мене часто запитують",
  FourLevels: "Послуги",
  aboutMethods: "Про матрицю",
  services: { buy_button: "Записатися", include: "Включає" },
};

export default mainUa;
